import { render, staticRenderFns } from "./Paso0.vue?vue&type=template&id=212e0b9a&lang=pug&"
import script from "./Paso0.vue?vue&type=script&lang=js&"
export * from "./Paso0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports